import * as React from 'react';
import { cn } from '../../lib/utils';

type BannerTone = 'note' | 'warn' | 'stop';

interface BannerProps {
  tone?: BannerTone;
  title?: string;
  children: React.ReactNode;
  icon?: string;
  className?: string;
}

const TONES: Record<BannerTone, string> = {
  note: 'bg-accent-soft/60 text-accent border-accent/20',
  warn: 'bg-amber-soft/70 text-amber border-amber/20',
  stop: 'bg-rose-soft/70 text-rose border-rose/20',
};

export const Banner = ({ tone = 'note', title, children, icon = 'i', className }: BannerProps) => (
  <div className={cn('flex gap-3 rounded-xl border px-4 py-3', TONES[tone], className)}>
    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-current/15 font-mono text-xs font-bold">
      {icon}
    </span>
    <div className="text-xs leading-relaxed">
      {title && <span className="font-semibold">{title} </span>}
      <span className="opacity-90">{children}</span>
    </div>
  </div>
);
